export default __webpack_public_path__ + "static/media/proceduresThumbnail.f6087af9.svg";